<template>
    <CContainer>
        <CRow>
            <h6>
                En este módulo podrá consultar la ejecución del presupuesto asignado al centro de costo.             
            </h6>
        </CRow>
        <CRow>
            <CCol>
                <CCard>
                    <CCardBody>
                        <CChartPie
                            style="height:300px"
                            :datasets="[
                            {
                                data: [
                                    80,
                                    5,
                                    15
                                ],
                                backgroundColor: [
                                    '#3f51b5',
                                    '#4a6ebb',
                                    '#804acd'
                                ],
                                label: 'Sales',
                            }
                            ]"
                            :labels="['Ejecutado', 'Disponible', 'Reservado']"
                            :options="{ maintainAspectRatio: false, responsive: true }"
                        />
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </CContainer>
</template>
<script>
  export default {
    name: 'BudgetExecution'
  }
</script>